import { render, staticRenderFns } from "./NbIcon.vue?vue&type=template&id=0a679b77&"
import script from "./NbIcon.vue?vue&type=script&lang=js&"
export * from "./NbIcon.vue?vue&type=script&lang=js&"
import style0 from "./NbIcon.vue?vue&type=style&index=0&id=0a679b77&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports